import React, { useEffect, useState, useRef } from 'react';
import { Card, Col, Container, Nav, Row, Table } from 'react-bootstrap';
import './pedidos.css'; // Certifique-se de importar o arquivo CSS
import Navbar from '../../components/navbar/navbar';

const Pedidos = () => {
    const [pedidos, setPedidos] = useState([]);
    const wsRef = useRef(null);

    useEffect(() => {
        const connect = () => {
            wsRef.current = new WebSocket(`ws://192.168.0.221:8080?conta=${localStorage.idconta}`);

            wsRef.current.onopen = () => {
                console.log('Conectado ao WebSocket');
            };

            wsRef.current.onmessage = (event) => {
                const updatedPedidos = JSON.parse(event.data);
                setPedidos(updatedPedidos);

                console.log(updatedPedidos);
            };

            wsRef.current.onclose = () => {
                console.log('Desconectado do WebSocket');
                // Tentar reconectar após 5 segundos
                setTimeout(() => {
                    console.log('Tentando reconectar...');
                    connect();
                }, 5000);
            };

            wsRef.current.onerror = (error) => {
                console.error('WebSocket error: ', error);
                wsRef.current.close();
            };
        };

        connect();

        const handleBeforeUnload = () => {
            if (wsRef.current) {
                wsRef.current.close();
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            if (wsRef.current) {
                wsRef.current.close();
            }
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    // Agrupar itens por pedido
    const pedidosAgrupados = pedidos.reduce((acc, item) => {
        if (!acc[item.pedido]) {
            acc[item.pedido] = [];
        }
        acc[item.pedido].push(item);
        return acc;
    }, {});

    return (
        <>
            <Navbar />

            <Container className="mt-page">
                {Object.keys(pedidosAgrupados).map((pedidoId) => (
                    <Row key={pedidoId} className="mb-4">
                        <Col>
                            <Card className="card-pedido">
                                <Card.Body>
                                    <Card.Title className="pedido-title">Pedido #{pedidoId}</Card.Title>
                                    <Card.Text>Status: {pedidosAgrupados[pedidoId][0].status}</Card.Text>
                                    <Card.Text>Cliente: {pedidosAgrupados[pedidoId][0].cliente}</Card.Text>
                                    <Card.Text>Conferente: {pedidosAgrupados[pedidoId][0].conferente}</Card.Text>
                                    <Card.Text>Data de Conferência: {pedidosAgrupados[pedidoId][0].data_conferencia}</Card.Text>
                                    <Card.Text>Data e Hora de Conf: {pedidosAgrupados[pedidoId][0].data_hora_conf}</Card.Text>
                                    <Card.Text>Apelido: {pedidosAgrupados[pedidoId][0].apelido}</Card.Text>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Descrição</th>
                                                <th>Quantidade</th>
                                                <th>Unidade</th>
                                                <th>SKU</th>
                                                <th>Código Item Pedido</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pedidosAgrupados[pedidoId].map((produto) => (
                                                <tr key={produto.codigo_itempedido}>
                                                    <td>{produto.descricao}</td>
                                                    <td>{produto.quantidade_total}</td>
                                                    <td>{produto.unidade}</td>
                                                    <td>{produto.sku}</td>
                                                    <td>{produto.codigo_itempedido}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ))}
            </Container>
        </>
    );
};

export default Pedidos;
